/* Gallery preloader
 * The horizontal slideshows/galleries keep loading="lazy" on their images so
 * pages stay light. That makes clicking through them feel buggy, because each
 * off-screen slide only starts downloading once you scroll/click to it.
 *
 * This warms the browser cache for an interactive gallery ~400px before it
 * enters the viewport, so slides are ready by the time you click. Only the
 * galleries listed below are treated this way — every other lazy image on the
 * page (collages, product tiles, grids) still loads purely on demand.
 *
 * It covers two shapes: scroll-snap tracks (warms each <img>), and the
 * thumbnail-swap gallery on the About page (warms the full-size URLs held in
 * each thumbnail's data-full attribute, so a click swaps in an already-cached
 * image instead of fetching a fresh 2000px file).
 */
(function () {
  var SELECTOR = [
    '.cd-slideshow-track',   // collection detail — hero slideshow
    '.cd-gallery-main',      // collection detail — bottom gallery slideshow
    '.ab-slideshow-track',   // about — slideshow
    '.ab-gallery',           // about — bottom gallery (big image + thumbnails)
    '.pdp-hero-track'        // product — main image slideshow
  ].join(', ');

  var tracks = document.querySelectorAll(SELECTOR);
  if (!tracks.length) return;

  function preload(url) {
    if (!url) return;
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = url; // populates the HTTP cache; the real img then loads instantly
  }

  function warm(container) {
    container.querySelectorAll('img').forEach(function (img) {
      preload(img.currentSrc || img.getAttribute('src'));
    });
    container.querySelectorAll('[data-full]').forEach(function (el) {
      preload(el.getAttribute('data-full'));
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { warm(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '400px 0px' });
    tracks.forEach(function (t) { io.observe(t); });
  } else {
    tracks.forEach(warm);
  }
})();
